import { DatePicker } from 'components/Input';
import React from 'react';
import { useSelector } from 'react-redux';
import selectors from 'state/selectors';
import styled from 'styled-components/macro';
import utils from 'utils';
import { RangeDate } from '../routes/dashboard';
import CheckBox from 'components/Buttons/CheckboxButton';

const DateWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

const LabelInput = styled.span`
  font-size: 12px;
  margin: 0px 5px;
`;

const CheckBoxContainer = styled.div`
  margin-right: 10px;
`;

interface DateFiltersProps {
  date?: Date;
  setDate?: (date: Date) => void;
  rangeDateActive?: boolean;
  setRangeDateActive?: (checkRangeDate: boolean) => void;
  rangeDate?: RangeDate;
  setRangeDate?: (rangeDate: RangeDate) => void;
}

const DateFilters = (props: DateFiltersProps) => {
  const { setDate, date, rangeDateActive, setRangeDateActive, rangeDate, setRangeDate } = props;

  const t = utils.intl.useTranslator();
  const dateFormat = useSelector(selectors.user.getUserPreference).dateFormat;

  return (
    <DateWrapper>
      <CheckBoxContainer>
        <CheckBox
          label={t('Range')}
          name="Range"
          isActive={rangeDateActive}
          action={() => setRangeDateActive && setRangeDateActive(!rangeDateActive)}
        />
      </CheckBoxContainer>
      {rangeDateActive ? (
        <>
          <DateWrapper>
            <LabelInput>{t('from:')}</LabelInput>
            <DatePicker
              selected={rangeDate?.from}
              onChange={(date) =>
                setRangeDate &&
                setRangeDate({
                  from: date,
                  to: rangeDate ? rangeDate.to : null,
                })
              }
              dateFormat={dateFormat}
              placeholderText={dateFormat?.toUpperCase()}
              maxDate={rangeDate?.to}
              isClearable
              inputWidth="120px"
            />
          </DateWrapper>
          <DateWrapper>
            <LabelInput>{t('to:')}</LabelInput>
            <DatePicker
              selected={rangeDate?.to}
              onChange={(date) =>
                setRangeDate &&
                setRangeDate({
                  from: rangeDate ? rangeDate.from : null,
                  to: date,
                })
              }
              dateFormat={dateFormat}
              placeholderText={dateFormat?.toUpperCase()}
              minDate={rangeDate?.from}
              isClearable
              inputWidth="120px"
            />
          </DateWrapper>
        </>
      ) : (
        <DatePicker
          selected={date}
          onChange={(date) => date && setDate && setDate(date)}
          dateFormat={dateFormat}
          placeholderText={dateFormat?.toUpperCase()}
          maxDate={new Date()}
        />
      )}
    </DateWrapper>
  );
};

export default DateFilters;
